import { render, staticRenderFns } from "./ActiveYear.vue?vue&type=template&id=5b619634&"
import script from "./ActiveYear.vue?vue&type=script&lang=js&"
export * from "./ActiveYear.vue?vue&type=script&lang=js&"
import style0 from "./ActiveYear.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports